/* eslint-disable import/prefer-default-export */
import { httpService } from 'core-utilities';
import { Result } from '../../result';
import { toResult } from '../common';
import * as Translations from '../types/translations';

export const getLanguageResources = <K extends ReadonlyArray<string>>(
  consumerType: Translations.ConsumerType,
  contentNamespace: string,
  keys: K
): Promise<
  Result<Translations.GetLanguageResourcesReturnType<K>, Translations.TranslationsError | null>
> =>
  toResult(
    httpService.get(Translations.GET_LANGUAGE_RESOURCES_CONFIG, {
      consumerType,
      contentNamespace,
      keys
    }),
    Translations.TranslationsError
  );
